import React from 'react';
import Button from '../common/Button';

/**
 * Stepper for how many copies of a card the decklist holds. Same shape as
 * AddToCollectionButton, but it reports the change upward instead of talking to a
 * context — the decklist lives in the textarea, not on the server.
 */
const DeckQuantityButton = ({ quantity, onChange }) => {
  const copies = quantity || 0;

  if (!copies) {
    return (
      <Button
        className="w-full"
        iconClass="fas fa-plus"
        onClick={() => onChange(1)}>
        Agregar al mazo
      </Button>
    );
  }

  return (
    <div className="flex flex-row items-center gap-x-1">
      <Button
        className="w-10 shrink-0"
        iconClass="fas fa-minus"
        onClick={() => onChange(copies - 1)}
      />
      <span className="flex-1 text-center text-white">{copies} en el mazo</span>
      <Button
        className="w-10 shrink-0"
        iconClass="fas fa-plus"
        onClick={() => onChange(copies + 1)}
      />
    </div>
  );
};

export default DeckQuantityButton;
